export default __webpack_public_path__ + "static/media/stake-more-bcube-eth.2dabc20f.svg";